const mutations = {
  loading (state, isLoading) {
    // console.log({ isLoading })
    if (isLoading) {
      state.isLoading = true
    } else {
      state.isLoading = false
    }
  },
  IDENTITY_CHECK (state, payload) {
    state.failIdentity = payload
  },
  SET_VERSION_CHECK (state, payload) {
    state.version = payload
  },
  SET_IDENTITY (state, encData) {
    state.encData = encData
  },
  SET_PRIVACY (state, privacyCheck) {
    state.view.authorizeChecked.privacyCheck = privacyCheck
  },
  SET_TERMS (state, termsCheck) {
    state.view.authorizeChecked.termsCheck = termsCheck
  },
  SET_TEMPORARY_PRIVACY (state, privacyCheck) {
    state.view.authorizeChecked.temporaryPrivacyCheck = privacyCheck
  },
  SET_TEMPORARY_TERMS (state, termsCheck) {
    state.view.authorizeChecked.temporaryTermsCheck = termsCheck
  },
  SET_INFO_LOGING (state, toggle) {
    state.view.isLogin = toggle
  },
  SET_POPUP (state, toggle) {
    state.checkPopup = toggle
  },
  SET_CHAT (state, toggle) {
    state.checkChat = toggle
  },
  SET_BADGE_COUNT (state, payload) {
    state.badgeCount = payload
  },
  SET_POPUP_HEADIS_LOGINER (state, toggle) {
    state.checkPopupHeader = toggle
  },
  SET_POPUP_HEADER_MAIN (state, toggle) {
    state.checkPopupHeaderMain = toggle
  },
  SET_POPUP_SIDE (state, toggle) {
    state.checkPopupSide = toggle
  },
  SET_ID (state, id) {
    state.userData.id = id
  },
  SET_NAME (state, userName) {
    state.userData.userName = userName
  },
  SET_MAIL (state, mail) {
    state.userData.mail = mail
  },
  SET_USER_DATA (state, userData) {
    state.userData.id = userData.id
    state.userData.userName = userData.userName
    state.userData.tel = userData.tel
    state.userData.birthDate = userData.birthDate
  },
  SET_TEL_RESERVATION_CARRY (state, telDataCarry) {
    state.telDataCarry.userName = telDataCarry.userName
    state.telDataCarry.tel = telDataCarry.tel
    state.telDataCarry.requestContents = telDataCarry.requestContents
    state.telDataCarry.visitPathCode = telDataCarry.visitPathCode
    state.telDataCarry.checkAgreements = telDataCarry.checkAgreements
  },
  SET_COMING_LIST (state, coming) {
    state.coming.list = coming.list
  },
  SET_COMING (state, coming) {
    state.coming.comingReasonCategory = coming.comingReasonCategory
    state.coming.comingReasonCode = coming.comingReasonCode
    state.coming.visitPathCode = coming.visitPathCode
    state.coming.etc = coming.etc
    state.coming.etcReason = coming.etcReason
    state.coming.etcContents = coming.etcContents
    state.coming.content = coming.content
  },
  SET_COMING_TELL (state, comingTell) {
    state.comingTell.userName = comingTell.userName
    state.comingTell.tel = comingTell.tel
    state.comingTell.requestContents = comingTell.requestContents
    state.comingTell.comingReasonCategory = comingTell.comingReasonCategory
    state.comingTell.comingReasonCode = comingTell.comingReasonCode
    state.comingTell.visitPathCode = comingTell.visitPathCode
    state.comingTell.etc = comingTell.etc
    state.comingTell.etcReason = comingTell.etcReason
    state.comingTell.etcContents = comingTell.etcContents
    state.comingTell.content = comingTell.content
  },
  SET_DOCTOR (state, doctorInfo) {
    state.doctorInfo = doctorInfo
  },
  SET_DOCTOR_CODE (state, code) {
    state.doctorCode = code
  },
  SET_SCHEDULE (state, doctorSchedule) {
    state.doctorSchedule = doctorSchedule
  },
  SET_CALENDAR_LIST (state, calendarList) {
    state.calendarList.list = calendarList
  },
  SET_RESERVATION_LIST (state, reservationList) {
    state.reservationList = reservationList
  },
  SET_PUSH_RESULT (state, result) {
    state.pushList.result = result
  },
  SET_PUSH_COUNT (state, result) {
    state.pushList.count = result
  },
  SET_PUSH_LIST (state, list) {
    state.pushList.list = list
  },
  SET_PUSH_CHECK (state, check) {
    state.pushList.check = check
  },
  SET_VISIT_LIST (state, visit) {
    state.visit.list = visit.list
  },
  SET_USERNAME (state, userName) {
    state.userData.userName = userName
  },
  CLEAR_USERNAME (state) {
    state.userData.userName = ''
  },
  SET_TOKEN_PERIOD (state, tokenPeriod) {
    state.userData.tokenPeriod = tokenPeriod
  },
  SET_TOKEN (state, token) {
    state.userData.token = token
  },
  SET_CHECKED_PW (state, action) {
    state.userData.checkedPw = action
  },
  SET_PASSED_LOGIC (state, payload) {
    state.view.logicPassed = payload
  },
  SET_TEMPORARY_DATA (state, temporaryData) {
    state.temporaryData.userName = temporaryData.userName
    state.temporaryData.gender = temporaryData.gender
    state.temporaryData.birthDate = temporaryData.birthDate
    state.temporaryData.userNameFlag = temporaryData.userNameFlag
    state.temporaryData.genderFlag = temporaryData.genderFlag
    state.temporaryData.birthDateFlag = temporaryData.birthDateFlag
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo.list = userInfo
  },
  SET_CAUSE_ACTION (state, toggle) {
    state.view.isCauseAction = toggle
  },
  SET_STYLE (state, frame) {
    state.modalHeight = frame || '210px'
  },
  DELETE_USER_NAME (state, payload) {
    state.userData.userName = payload
  },
  SET_TARGET_DATE (state, date) {
    state.calendarList.targetDate = date
  },
  SET_DEVICE_PUSHKEY (state, pushKey) {
    state.device.pushKey = pushKey
  },
  SET_DEVICE_DEVICE (state, device) {
    state.device.device = device
  },
  SET_DEVICE_DEVICEID (state, deviceId) {
    state.device.deviceId = deviceId
  },
  SET_DEVICE_APPVERSION (state, appVersion) {
    state.device.appVersion = appVersion
  },
  SET_RESERVATION_CHECK (state, payload) {
    state.reservationInfo = payload
  },
  SET_RESERVATION_MESSAGE (state, payload) {
    state.view.reservationDone = payload
  },

  SET_SCARDETAIL_INIT_MESSAGE (state, payload) {
    state.view.scarUploadEscape = payload
  },
  SET_UPLOAD_MESSAGE (state, payload) {
    state.view.scarUploadDone = payload
  },
  SET_DELETEDONE_MESSAGE (state, payload) {
    state.view.deleteReservationDone = payload
  },
  SET_RESERVATION_UPDATE_FAIL_MESSAGE (state, payload) {
    state.view.reservationUpdateQuit = payload
  },
  SET_RESERVATION_UPDATE_DONE_MESSAGE (state, payload) {
    state.view.reservationUpdateDone = payload
  },
  SET_RESERVATION_INIT_MESSAGE (state, payload) {
    state.view.reservationInit = payload
  },
  SET_REDIRECT_MAIN_MESSAGE (state, payload) {
    state.view.redirectMainMessage = payload
  },
  SET_RESERVATION_SEARCH (state, payload) {
    state.reservationListInfo = payload
  },
  SET_RESERVATION_ITEM_INFO (state, payload) {
    state.reservationItemInfo = payload
  },
  SET_SURGERY_LIST (state, payload) {
    state.surgery.surgeryList = payload
  },
  SET_SURGERY_DATE (state, payload) {
    state.surgeryDate = payload
  },
  SET_KAKAO_URL (state, payload) {
    state.surgery.kakaoUrl = payload
  },
  SET_REBOOKINGSET (state, payload) {
    state.reBookingSet = payload
  },
  SET_PRE_REASERVATION (state, payload) {
    state.preReservation = payload
  },
  SET_CHECKAGREEMENT (state, payload) {
    state.view.guestCheckAgreement = payload
  },
  SET_SCARINFO_LIST (state, payload) {
    state.scarInfoList = payload
  },
  SET_BANNER (state, payload) {
    state.banner = payload
  },
  SET_BANNER_DETAIL (state, payload) {
    state.bannerDetail = payload
  },
  SET_SURGERY_DONE (state, payload) {
    state.view.surgeryDone = payload
  },
  SET_SURGERY_CODE (state, payload) {
    state.surgeryCodeSet = payload
  },
  SET_SCAR_INFOCODE (state, payload) {
    state.scarInfoCode = payload
  },
  SET_MEDICAL_MONTH_DATE (state, payload) {
    state.medicalMonthDate = payload
  },
  SET_SCAR_INFO (state, payload) {
    state.scarInfoData = payload
  },
  SET_UPLOAD_LIST (state, payload) {
    state.scarUploadList = payload
  },
  SET_FETCHED_SCARIMG (state, payload) {
    state.scarFetchedImg = payload
  },
  SET_UPLOAD_PRE_DATA (state, payload) {
    state.uploadPreData = payload
  },
  SET_PREV_URL (state, payload) {
    state.prevUrl = payload
  },
  SET_REFRESH_APPHEADER (state, payload) {
    state.view.refreshAppHeader = payload
  },
  SET_SIDEBAR_OPEN (state, payload) {
    state.view.isSideBarOpen = payload
  },
  SET_CAUSE_AUTHERROR (state, payload) {
    state.isCauseAuthError.status = payload.status
    state.isCauseAuthError.url = payload.url
  },
  SET_AUTO_LOGIN_DONE (state, payload) {
    state.view.autoLoginDone = payload
  },
  SET_SIDEBAR_ALARM (state, payload) {
    state.view.sidebarAlarm = payload
  },
  SET_PUSH_ABLE (state, payload) {
    state.view.pushAble = payload
  },
  SET_RESV_CODE (state, payload) {
    state.param.resvCode = payload
  },
  SET_RESERVATION_RESULT (state, payload) {
    state.view.reservationDone = payload
  }
}

/* visit () {
    return request.get('/reservation/visit')
      .then(({ data }) => data)
  },
  VISIT_LIST ({ commit }) {
    return reservation.visit()
      .then((data) => commit('SET_VISIT_LIST', data.response))
  },
  SET_VISIT_LIST (state, visit) {
    state.visit.list = visit.list
  }, */

export default mutations
